/* =============================================================================
 * Footer menu accordions — v1.0 §8.16, mobile only.
 *
 * Split from component-header.js by behaviour to stay inside the §P.3 250-line
 * JavaScript limit.
 *
 * Panels are open in the markup so the footer is fully usable with JavaScript
 * disabled; they are collapsed here only below 750 px.
 *
 * F-2 FIX. This was previously a plain function bound once at load. External
 * scripts do not re-execute when the Theme Editor re-renders a section, so
 * after any Editor change the new toggles had no listeners and the accordions
 * stopped working.
 *
 * It is now a custom element, registered through window.Eloss.define — the
 * same mechanism eloss-header and eloss-announcement-bar already use. The
 * browser calls connectedCallback on every re-render and disconnectedCallback
 * on every teardown, so binding is automatic and cannot accumulate: each
 * element instance owns only its own listeners, and the media-query listener
 * is released on disconnect. This is Shopify's own Dawn pattern, not new
 * architecture.
 * ========================================================================== */

(() => {
  const Eloss = window.Eloss;
  if (!Eloss) return;

  const MOBILE = '(max-width: 749px)';

  Eloss.define('eloss-footer', class ElossFooter extends HTMLElement {
    connectedCallback() {
      this.toggles = Array.from(this.querySelectorAll('[data-footer-accordion]'));
      if (this.toggles.length === 0) return;

      this.mq = window.matchMedia(MOBILE);
      this.onToggle = (e) => this.handleToggle(e.currentTarget);
      this.onChange = () => this.sync();

      this.toggles.forEach((btn) => btn.addEventListener('click', this.onToggle));
      this.mq.addEventListener('change', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      /* Released here so repeated Theme Editor re-renders cannot accumulate. */
      this.toggles?.forEach((btn) => btn.removeEventListener('click', this.onToggle));
      this.mq?.removeEventListener('change', this.onChange);
      this.toggles = null;
    }

    panelFor(btn) {
      const id = btn.getAttribute('aria-controls');
      return id ? this.querySelector(`#${CSS.escape(id)}`) : null;
    }

    handleToggle(btn) {
      if (!this.mq.matches) return; // Desktop headings are static labels (§8.16).
      const panel = this.panelFor(btn);
      if (!panel) return;
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    }

    sync() {
      const mobile = this.mq.matches;
      this.toggles.forEach((btn) => {
        const panel = this.panelFor(btn);
        if (!panel) return;
        btn.setAttribute('aria-expanded', String(!mobile));
        panel.hidden = mobile;
      });
    }
  });
})();
